import {apiConfig} from '@ibibo/hotels-config';
// import {pushToNewrelic} from '../../afore/app/redux/actions/dexter-actions';

export function loadNewPaymentsOptions(data = null) {
  let count = 5;
  const success = () => {
    if (data) {
      window.initPayment(data);
    }
  };
  const error = (err, scriptTag, callback) => {
    count--;
    console.trace(err);
    //   pushToNewrelic('serviceApp=hotelsMwebPayment&paymentv2failed=true');
    scriptTag.parentNode.removeChild(scriptTag);
    if (count) {
      callback();
    }
  };
  function loadJS() {
    const jsElm = document.createElement('script');
    jsElm.type = 'application/javascript';
    jsElm.src = `${__ENV_CONFIG__.GOIBIBO}/mudra/dist/loadPayments.js?cb=${Math.random()}`;
    jsElm.onload = success;
    jsElm.onerror = () => {
      error('payments failed', jsElm, loadJS);
    };
    document.body.appendChild(jsElm);
  }
  loadJS();
}
